import { AxiosPromise } from "axios";
import { apiWrapper } from "../../axiosInstance";
import { GeoCalculationsServiceResponse } from "./geoCalculations.service";

export const geoCalculationsEndpoint = (): AxiosPromise<GeoCalculationsServiceResponse> =>
    apiWrapper.instance!.get(`rest/sdo/geoCalculations`);
